import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { omit } from "lib/omit"
import { usePayloadTask } from "routes/facilities/lib/use-payload-task"
import { comparePayloadWithOriginal } from "routes/schedule/compare/lib/compare-payload-with-original"
import { TailoredAudit } from "./tailored-audit"

export function TaskTailored({ children }) {
    const { task } = useBoundContext()
    const originalTask = { ...task, included: true }
    const payloadTask = usePayloadTask()

    const payloadComparisonTask = omit(payloadTask, "introduction", "notes", "suppressZeroU", "tailored")
    const taskTailored = !comparePayloadWithOriginal(payloadComparisonTask, originalTask)

    return (
        <Bound taskTailored={taskTailored} originalTask={originalTask} tailoredTask={payloadTask}>
            <TailoredAudit>{children}</TailoredAudit>
        </Bound>
    )
}
